import React from "react";
import clsx from "clsx";
import { Toolbar as ToolbarMUI, AppBar, Container } from "@material-ui/core";
import useStyles from "src/molecules/Toolbar/styles.jsx";
import PropTypes from "prop-types";

const Toolbar = ({ open, children, elevation }) => {
  const classes = useStyles();
  return (
    <AppBar
      elevation={elevation || 0}
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
    >
      <Container>
        <ToolbarMUI className={classes.toolbar}>{children}</ToolbarMUI>
      </Container>
    </AppBar>
  );
};

Toolbar.propTypes = {
  open: PropTypes.bool,
};

export { Toolbar };
